import React, { useEffect, useState } from 'react';
import api from '../../utils/axios';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Switch } from '../ui/switch';
import { toast } from 'sonner';
import { Landmark, Plus, Save, Trash2 } from 'lucide-react';

export const BancosSponsorEditor = () => {
  const [bancos, setBancos] = useState([]);
  const [meta, setMeta] = useState({});
  const [saving, setSaving] = useState(false);

  const cargar = async () => {
    try {
      const res = await api.get('/system-config/bancos-sponsor');
      setBancos(res.data?.bancos || []);
      setMeta(res.data || {});
    } catch {
      toast.error('No se pudieron cargar los bancos sponsor');
    }
  };
  useEffect(() => { cargar(); }, []);

  const set = (i, campo, valor) => setBancos((bs) => bs.map((b, j) => (j === i ? { ...b, [campo]: valor } : b)));

  const guardar = async () => {
    setSaving(true);
    try {
      const res = await api.put('/system-config/bancos-sponsor', { bancos });
      setBancos(res.data?.bancos || []);
      setMeta(res.data || {});
      toast.success('Bancos sponsor guardados');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Error al guardar');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card className="p-5 border-slate-200" data-testid="bancos-sponsor-editor">
      <div className="flex items-start gap-3 mb-3">
        <div className="p-2 rounded-lg bg-indigo-50"><Landmark size={18} className="text-indigo-600" /></div>
        <div className="flex-1">
          <h3 className="font-semibold text-slate-900">Bancos sponsor</h3>
          <p className="text-xs text-slate-500">
            Se identifica por los primeros 13 dígitos del CVU. "Activo" = sponsor vigente (destino de los reemplazos).
            {meta.actualizado_por && <> Última modificación: {meta.actualizado_por}.</>}
          </p>
        </div>
      </div>
      <div className="space-y-2">
        {bancos.map((b, i) => (
          <div key={i} className="flex items-center gap-2" data-testid={`banco-sponsor-row-${i}`}>
            <Input value={b.prefijo} onChange={(e) => set(i, 'prefijo', e.target.value)} className="font-mono text-xs w-44 h-8" placeholder="Prefijo (13 dígitos)" data-testid={`banco-sponsor-prefijo-${i}`} />
            <Input value={b.nombre} onChange={(e) => set(i, 'nombre', e.target.value)} className="text-sm h-8 flex-1" placeholder="Nombre del banco" data-testid={`banco-sponsor-nombre-${i}`} />
            <Switch checked={!!b.activo} onCheckedChange={(v) => set(i, 'activo', v)} data-testid={`banco-sponsor-activo-${i}`} />
            <span className={`text-xs w-16 ${b.activo ? 'text-emerald-600' : 'text-slate-400'}`}>{b.activo ? 'Activo' : 'Inactivo'}</span>
            <Button variant="ghost" size="sm" className="h-8 w-8 p-0" onClick={() => setBancos((bs) => bs.filter((_, j) => j !== i))} data-testid={`banco-sponsor-quitar-${i}`}>
              <Trash2 size={14} className="text-rose-400" />
            </Button>
          </div>
        ))}
      </div>
      <div className="flex gap-2 mt-3">
        <Button variant="outline" size="sm" onClick={() => setBancos((bs) => [...bs, { prefijo: '', nombre: '', activo: false }])} data-testid="banco-sponsor-agregar">
          <Plus size={14} className="mr-1" /> Agregar prefijo
        </Button>
        <Button size="sm" onClick={guardar} disabled={saving} data-testid="banco-sponsor-guardar">
          <Save size={14} className="mr-1" /> {saving ? 'Guardando…' : 'Guardar'}
        </Button>
      </div>
    </Card>
  );
};
